module.exports = __webpack_public_path__ + "img/access-delete.34a4bfd0.svg";